import { UserProfile } from '@/models/userdata/profile';

const LOGGED_IN_OPENING_TAG_REGEX = /{{ *loggedin *}}/g;
const LOGGED_IN_CLOSING_TAG_REGEX = /{{ *endloggedin *}}/g;
const LOGGED_OUT_OPENING_TAG_REGEX = /{{ *notloggedin *}}/g;
const LOGGED_OUT_CLOSING_TAG_REGEX = /{{ *endnotloggedin *}}/g;

const BRANDING_LOGO_REGEX = /{{ *branding_logo_url *}}/g;
const LOGING_URL_REGEX = /{{ *login_url *}}/g;
const SIGN_UP_URL_REGEX = /{{ *sign_up_url *}}/g;
const FIND_JOBS_URL_REGEX = /{{ *find_jobs_url *}}/g;
const SAVED_JOBS_URL_REGEX = /{{ *saved_jobs_url *}}/g;
const ANON_SAVED_JOBS_URL_REGEX = /{{ *anon_saved_jobs_url *}}/g;
const REFER_A_FRIEND_URL_REGEX = /{{ *refer_a_friend_url *}}/g;
const ANON_REFER_A_FRIEND_URL_REGEX = /{{ *anon_refer_a_friend_url *}}/g;
const TERMS_OF_SERVICE_URL_REGEX = /{{ *terms_of_service_url *}}/g;
const PRIVACY_POLICY_URL_REGEX = /{{ *privacy_policy_url *}}/g;

const HOME_URL_REGEX = /{{ *home_url *}}/g;
const MY_JOBS_URL_REGEX = /{{ *my_jobs_url *}}/g;
const JOB_ALERTS_URL_REGEX = /{{ *job_alerts_url *}}/g;
const SURVEY_URL_REGEX = /{{ *survey_url *}}/g;
const MY_REFERRAL_URL_REGEX = /{{ *my_referrals_url *}}/g;
const FORUM_URL_REGEX = /{{ *forum_url *}}/g;
const HELP_URL_REGEX = /{{ *help_url *}}/g;
const LOGOUT_URL_REGEX = /{{ *logout_url *}}/g;
const USER_PROFILE_URL_REGEX = /{{ *user_profile_url *}}/g;
const USER_FULL_NAME_REGEX = /{{ *user_full_name *}}/g;
const USER_INITIALS_REGEX = /{{ *user_initials *}}/g;
const USER_EMAIL_REGEX = /{{ *user_email *}}/g;
const USER_PROFILE_PICTURE_URL_REGEX = /{{ *user_profile_picture_url *}}/g;
const HAS_PROFILE_PICTURE_REGEX = /{{ *has_profile_picture *}}/g;
const DOES_NOT_HAVE_PROFILE_PICTURE_REGEX = /{{ *! *has_profile_picture *}}/g;

const LOGGED_IN_FLAG_REGEX = /{{ *is_logged_in *}}/g;
const NOT_LOGGED_IN_FLAG_REGEX = /{{ *! *is_not_logged_in *}}/g;

const LIFE_AT_LABEL = /{{ *life_at *}}/g;
const COMPANY_NAME = /{{ *companyName *}}/g;
const REFER_A_FRIEND_LABEL = /{{ *refer_a_friend_label *}}/g;
const BROWSE_JOBS_LABEL = /{{ *browse_jobs_label *}}/g;
const HEADER_LOGIN_BUTTON_LABEL = /{{ *header_login_button_label *}}/g;
const HEADER_JOIN_TALENT_COMMUNITY_LABEL = /{{ *header_join_talent_community_label *}}/g;

export const LOGGED_IN_OPENING_TAG = '{{loggedin}}';
export const LOGGED_IN_CLOSING_TAG = '{{endloggedin}}';
export const LOGGED_OUT_OPENING_TAG = '{{notloggedin}}';
export const LOGGED_OUT_CLOSING_TAG = '{{endnotloggedin}}';
export const HAS_PROFILE_PICTURE_FLAG = '{{has_profile_picture}}';
export const DOES_NOT_HAVE_PROFILE_PICTURE_FLAG = '{{!has_profile_picture}}';
export const LOGGED_IN_FLAG = '{{is_logged_in}}';
export const NOT_LOGGED_IN_FLAG = '{{!is_logged_in}}';

export const LOGING_URL = '/atsuser/login';
export const SIGN_UP_URL = '/atsuser/signup';
export const FIND_JOBS_URL = '/atsuser/findjobs';
export const SAVED_JOBS_URL = '/atsuser/savedjobs';
export const ANON_SAVED_JOBS_URL = '/atsuser/anonsavedjobs';
export const REFER_A_FRIEND_URL = '/atsuser/referafriend';
export const ANON_REFER_A_FRIEND_URL = '/atsuser/anonreferafriend';

export const HOME_URL = '/atsuser/home';
export const MY_JOBS_URL = '/atsuser/myjobstatus';
export const JOB_ALERTS_URL = '/atsuser/jobAlert';
export const SURVEY_URL = '/atsuser/survey';
export const MY_REFERRAL_URL = '/atsuser/myreferralslist';
export const FORUM_URL = '/atsuser/forum';
export const HELP_URL = '/atsuser/help';
export const LOGOUT_URL = '/atsuser/logout';
export const USER_PROFILE_URL = '/atsuser/myprofile/v2/details';

const initials = (fullName: string) => {
  if (!fullName) return '';
  return fullName.split(' ').map(w => w.trim() ? w.trim().charAt(0) : '').join('').toUpperCase();
}

export const validateConditionalTags = (
  html: string,
  openingTag: string,
  closingTag: string,
  condition: boolean,
) => {
  let result = html;
  // Control LoguedIn blocks (show/remove contents)
  let openingTagIndex = result.indexOf(openingTag);
  while (openingTagIndex >= 0) {
    let closingTagIndex = result.indexOf(closingTag);
    if (closingTagIndex < 0)
      return `<div>Content error: could not find ${openingTag} closing mark for ${closingTag} mark in position ${openingTagIndex} </div>`;
    if (condition)
      result = result.replace(openingTag, '').replace(closingTag, '');
    else
      result =
        result.substring(0, openingTagIndex) +
        result.substring(closingTagIndex + closingTag.length);
    openingTagIndex = result.indexOf(openingTag);
  }
  return result;
}

export const evalHtmlContent = (
    htmlContent: string,
    isLoggedIn: boolean,
    brandingLogo: string,
    user: UserProfile,
    termsOfService: string = '',
    privacyPolicy: string = '',
    companyName: string = '',
    life_at_label: string = '',
    refer_a_friend_label: string = '',
    browse_jobs_label: string = '',
    header_login_button_label: string = '',
    header_join_talent_community_label: string = '',
    ) => {

  const userFullName = user ? `${user.firstName} ${user.lastName}` : ''
  const userEmail = user ? user.email : '';
  const profilePicture = user && user.profilePicGUID ? `${user.userProfileBasePath}${user.profilePicGUID}.${user.profilePicExtType}` : '';
  const hasProfilePicture = profilePicture ? true : false;
  let html = htmlContent;
  // Replace urls
  html = html.replace(BRANDING_LOGO_REGEX, brandingLogo);
  html = html.replace(LOGING_URL_REGEX, LOGING_URL);
  html = html.replace(SIGN_UP_URL_REGEX, SIGN_UP_URL);
  html = html.replace(FIND_JOBS_URL_REGEX, FIND_JOBS_URL);
  html = html.replace(SAVED_JOBS_URL_REGEX, SAVED_JOBS_URL);
  html = html.replace(ANON_SAVED_JOBS_URL_REGEX, ANON_SAVED_JOBS_URL);
  html = html.replace(REFER_A_FRIEND_URL_REGEX, REFER_A_FRIEND_URL);
  html = html.replace(ANON_REFER_A_FRIEND_URL_REGEX, ANON_REFER_A_FRIEND_URL);
  html = html.replace(TERMS_OF_SERVICE_URL_REGEX, termsOfService);
  html = html.replace(PRIVACY_POLICY_URL_REGEX, privacyPolicy);

  html = html.replace(HOME_URL_REGEX, HOME_URL);
  html = html.replace(MY_JOBS_URL_REGEX, MY_JOBS_URL);
  html = html.replace(JOB_ALERTS_URL_REGEX, JOB_ALERTS_URL);
  html = html.replace(SURVEY_URL_REGEX, SURVEY_URL);
  html = html.replace(MY_REFERRAL_URL_REGEX, MY_REFERRAL_URL);
  html = html.replace(FORUM_URL_REGEX, FORUM_URL);
  html = html.replace(HELP_URL_REGEX, HELP_URL);
  html = html.replace(LOGOUT_URL_REGEX, LOGOUT_URL);
  html = html.replace(USER_PROFILE_URL_REGEX, USER_PROFILE_URL);
  html = html.replace(USER_FULL_NAME_REGEX, userFullName || '');
  html = html.replace(USER_EMAIL_REGEX, userEmail || '');
  html = html.replace(USER_INITIALS_REGEX, initials(userFullName) || '');

  html = html.replace(LIFE_AT_LABEL, life_at_label);
  html = html.replace(COMPANY_NAME, companyName);
  html = html.replace(REFER_A_FRIEND_LABEL, refer_a_friend_label);
  html = html.replace(BROWSE_JOBS_LABEL, browse_jobs_label);
  html = html.replace(HEADER_LOGIN_BUTTON_LABEL, header_login_button_label);
  html = html.replace(HEADER_JOIN_TALENT_COMMUNITY_LABEL, header_join_talent_community_label);


  // Normalize logged in control sentences
  html = html.replace(LOGGED_IN_OPENING_TAG_REGEX, LOGGED_IN_OPENING_TAG);
  html = html.replace(LOGGED_IN_CLOSING_TAG_REGEX, LOGGED_IN_CLOSING_TAG);
  html = html.replace(LOGGED_OUT_OPENING_TAG_REGEX, LOGGED_OUT_OPENING_TAG);
  html = html.replace(LOGGED_OUT_CLOSING_TAG_REGEX, LOGGED_OUT_CLOSING_TAG);

  // Replace only if the user has profile picture
  html = html.replace(USER_PROFILE_PICTURE_URL_REGEX, profilePicture);
  html.replace(USER_INITIALS_REGEX, initials(userFullName) || '');
  // Update Has Profile Picture condition
  html = html.replace(HAS_PROFILE_PICTURE_REGEX, `${hasProfilePicture}`);
  html = html.replace(DOES_NOT_HAVE_PROFILE_PICTURE_REGEX, `${!hasProfilePicture}`);

  html = html.replace(LOGGED_IN_FLAG_REGEX, `${isLoggedIn}`);
  html = html.replace(NOT_LOGGED_IN_FLAG_REGEX, `${!isLoggedIn}`);

  // Control LoguedIn blocks (show/remove contents)
  html = validateConditionalTags(
    html,
    LOGGED_IN_OPENING_TAG,
    LOGGED_IN_CLOSING_TAG,
    isLoggedIn,
  );
  html = validateConditionalTags(
    html,
    LOGGED_OUT_OPENING_TAG,
    LOGGED_OUT_CLOSING_TAG,
    !isLoggedIn,
  );
  return html;
}

